import React, { useState } from 'react';
import Loader from './Loader';
import { Document, Page, pdfjs } from 'react-pdf';
import ControlPanel from './ControlPanel';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = (props) => {
  const [scale, setScale] = useState(1.8);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  // const [pdfFile, setPdfFile] = useState(null);

  // const viewfile = __dirname + props.filepath;
  var viewfile = props.filepath;

  // const viewfile = "/..\\PDFfile\\SensorDrawing\\HLZ020003.pdf";
  // console.log("Get into PDFViewer __dirname : ", __dirname);
  // console.log("Get into PDFViewer filepath: ", viewfile);
  // console.log("Get into PDFViewer view-path : ", `${__dirname}/${viewfile}`);
  // alert(viewfile);

  // const process = require('process');
  // console.log("Get into PDFViewer Current working directory : ", process.cwd());

  function onDocumentLoadSuccess({ numPages }) {
    // console.log('onDocumentLoadSuccess isLoading :', isLoading);
    setNumPages(numPages);
    setIsLoading(false);
  }

  // const showPdf = (pdf) => {
  //   window.open(`http://localhost:3022/files/${pdf}`, "_blank", "noreferrer");
  //   window.open(`http://localhost:5000/files/${pdf}`, "_blank", "noreferrer");
  //   setPdfFile(`http://localhost:3022/files/${pdf}`)
  //   setPdfFile(`http://localhost:5000/files/${pdf}`)
  // };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <section id='pdf-section' className='d-flex flex-column align-items-center w-100' >
        <ControlPanel
          scale={scale} setScale={setScale}
          numPages={numPages} pageNumber={pageNumber} setPageNumber={setPageNumber}
          file={viewfile}
        // file={props.filepath}
        />
        {/* file="/assets/docs/file-sample2.pdf" */}
        {/* <Document file="/../../../PDFfile/SensorDrawing/HLZ020001.pdf" onLoadSuccess={onDocumentLoadSuccess} > */}
        {/* <Document file={props.filepath} onLoadSuccess={onDocumentLoadSuccess} > */}
        <Document file={viewfile} onLoadSuccess={onDocumentLoadSuccess} >
          <Page pageNumber={pageNumber} scale={scale} />
        </Document>
      </section>
    </div>
  );
};

export default PDFViewer;
